export default "__VITE_ASSET__BT3Z0tET__"